<template>
	<b-container fluid class="admin-project-code-page">
		<b-row class="">
			<b-col cols="12" lg="12">
                <div class="d-flex justify-content-between align-items-end border-bottom pb-3">
                    <div class="d-flex align-items-center">
                        <div class="page-title-icon mr-3">
                            <fa icon="folder-open" />
                        </div>
                        <div>
                            <h3 class="mb-1">프로젝트 관리</h3>
                            <p class="fw-400 text-secondary mb-0">Assessment에서 사용되는 프로젝트를 관리합니다.</p>
                        </div>
                    </div>
                </div>
			</b-col>
		</b-row>
		<template v-if="!is_loaded_projectCode" >
			<b-row class="admin-body-full-height mt-3">
				<b-col cols="12">
					<div class="d-flex flex-column align-items-center justify-content-center bgray-200 h-100 rounded">
						<b-spinner variant="primary" style="width: 2.5rem; height: 2.5rem;"></b-spinner>
						<h6 class="mb-0 mt-3 text-secondary">프로젝트를 불러오는 중입니다...</h6>
					</div>
				</b-col>
			</b-row>
		</template>
		<template v-else>
			<b-row class="mt-4">
				<b-col cols="12">
					<b-card no-body class="shadow-sm project-list-card" header-bg-variant="white">
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between flex-wrap">
                                <div class="d-flex align-items-center">
                                    <h5 class="mb-0">프로젝트 리스트</h5>
                                    <b-badge v-if="currentPeriodProjects.length" pill variant="primary" class="ml-2 f-85">
                                        {{ currentPeriodProjects.length }}건
                                    </b-badge>
                                </div>
                                <b-btn
                                    size="sm"
                                    variant="primary"
                                    :disabled="!is_loaded_projectCode"
                                    @click="openProjectModal"
                                    >
                                    <fa icon="plus" class="mr-2"></fa>프로젝트 추가하기
                                </b-btn>
                            </div>
                        </template>
						<b-tabs v-model="currentPeriodIndex"
							card
							>
							<b-tab
								v-for="(item) in projects" :key="item.id"
                                title-link-class="gray-500"
								active
                                no-body
								>
								<template #title>
									<span class="d-inline-flex align-items-center">
										{{ item.period }}
										<b-badge pill variant="light" class="ml-2 period-count-badge">{{ item.projects.length }}</b-badge>
									</span>
								</template>
								<b-table
									id="admin-payment-product-table"
									class="rep-table border-bottom border-color-gray-300 mb-0 sticky-header-sort-fix"

									:items="item.projects"
									:fields="project_fields"
									:busy="!is_loaded_projectCode"

									empty-html="<h6 class='mt-3 gray-400'>조회된 프로젝트코드가 없습니다.</h6>"
									details-td-class="bg-light"
									show-empty 
									hover
									responsive="sm"
									sticky-header="500px"
									no-border-collapse
									>

                                    <template #cell(campaign)="data">
										<template v-if="data.item.campaign">
											<div style="word-break: keep-all;">{{ data.item.campaign.name }}</div>
											<b-badge variant="light">{{ data.item.campaign.id }}</b-badge>
                                        </template>
										<template v-else>-</template>
									</template>

                                    <!--
                                        평가 그룹 미지정이면 이 프로젝트의 벤더코드가 평가 신청 화면에
                                        노출되지 않으므로, 대시(-)로 흘리지 않고 경고로 드러낸다.
                                    -->
                                    <template #cell(group_name)="data">
                                        <template v-if="data.item.group_name">
                                            <div style="word-break: keep-all;">{{ data.item.group_name }}</div>
                                            <b-badge variant="light">{{ data.item.group_name_en }}</b-badge>
                                        </template>
                                        <template v-else>
                                            <b-badge variant="danger">미지정</b-badge>
                                        </template>
                                    </template>

                                    <template #cell(client)="data">
                                        <div>{{ data.value }}</div>
                                        <div class="d-inline-block">
                                            <span class="f-75">({{ data.item.manager }})</span>
                                        </div>
                                    </template>

									<template #cell(client_id)="data">
										<template v-if="data.item.client_id">
											<div>{{ data.item.company_name }}</div>
											<b-badge variant="light">{{data.item.client_id}}</b-badge>
                                        </template>
										<template v-else>-</template>
									</template>

									<template #cell(vendor_code)="data">
										<b-badge pill class="status-pill" :variant="data.item.vendor_code ? 'success' : 'light'">
											{{ data.item.vendor_code ? 'ON' : 'OFF' }}
										</b-badge>
									</template>

									<template #cell(pay)="data">
										<b-badge pill class="status-pill" :variant="data.item.pay ? 'success' : 'light'">
											{{ data.item.pay ? 'ON' : 'OFF' }}
										</b-badge>
									</template>

									<template #cell(availability)="data">
										<b-badge pill class="status-pill" :variant="data.item.availability ? 'success' : 'light'">
											{{ data.item.availability ? 'ON' : 'OFF' }}
										</b-badge>
									</template>

									<template #cell(custom_template_code)="data">
										<code>{{!data.item.custom_template_code ? "-" : data.item.custom_template_code}}</code> 
									</template>

                                    <template #cell(start_date)="data">
                                        {{ data.value === '' ? '-' : data.value }}
                                    </template>

                                    <template #cell(end_date)="data">
                                        {{ data.value === '' ? '-' : data.value }}
                                    </template>

									<template #cell(edit)="data">
										<b-btn size="sm"
											variant="outline-secondary"
											class="edit-btn"
											@click="openProjectEditModal(data.item)"
											>
											<!-- 수정하기 -->
                                            <BIconPencilSquare />
										</b-btn>
									</template>
								</b-table>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>

			<b-modal id="add-new-project-modal"
				class="modal-content"
				centered
				size="lg"
				title="프로젝트 수정"
				hide-footer
				> 
				<edit-project
					:edit="edit === 'update'"
					:project="editing_target_project"
					:project_period="currentPeriodIndex ? projects[currentPeriodIndex].period : ''"
					@update-project="updateProject"
					@delete-project="deleteProject"
					@reset-project="resetProject"
					/>
			</b-modal>
		</template>
	</b-container>
</template>

<script>
import editProject from '@shared_components/admin/components/projects/edit-project'

export default {
	name: 'AdminProjectCode',
	props: [],
	components: {
		editProject
	},
	data () {
		return {
			projects:[],
			editing_target_project: {},

			edit: null,
			currentPeriodIndex: null,
			is_loaded_projectCode: false,
		
			project_fields: [
				{
					key: 'project_code',
					label: '프로젝트코드',
					sortable: true,
					thClass: 'mb-0'
				},
                {
					key: 'campaign',
					label: '캠페인',
					sortable: true,
					thClass: 'mb-0',
                    thStyle: 'width: 15%;'
				},
				{
					key: 'group_name',
					label: '평가 그룹',
					sortable: true,
					thClass: 'mb-0 text-nowrap'
				},
				{
					key: 'client',
					label: '원청사 (매니저)',
					sortable: true,
					thClass: 'mb-0 text-nowrap'
				},
				{
					key: 'client_id',
					label: '대시보드',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'custom_template_code',
					label: '커스텀 질문지',
					sortable: true,
					thClass: 'mb-0 text-nowrap'
				},
				{
					key: 'availability',
					label: '현재사용',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'pay',
					label: '유료',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'vendor_code',
					label: '업체 코드',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'start_date',
					label: '시작일',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'end_date',
					label: '종료일',
					sortable: true,
					thClass: 'mb-0'
				},
				{
					key: 'edit',
					label: '수정',
					sortable: false,
					thClass: 'mb-0 text-center'
				},
			]
		}
	},
	computed: {
		currentPeriodProjects () {
			const period = this.projects[this.currentPeriodIndex]
			return period && Array.isArray(period.projects) ? period.projects : []
		}
	},
	async created () {
		await this.getProjecCode()
	},
	methods: {
		async getProjecCode(){
			try {
                console.log(`getProjecCode ~ `);
                
				this.is_loaded_projectCode = false
				const response = await this.$axios.get('/project_code')
				this.projects = response.data.reduce((_projectGroup, _projectByPeriod) => {
					if (_projectByPeriod.projects.length) {
						_projectByPeriod.projects = _projectByPeriod.projects.reduce((_projects, _project) => {
							_projects.push({ ..._project,
								start_date: this.formatDate(_project.start_date, 'YYYY-MM-DD'),
								end_date: this.formatDate(_project.end_date, 'YYYY-MM-DD')
							})
							return _projects
						}, [])
						// 최신순(id 내림차순) 정렬 — id가 큰(최근 생성된) 프로젝트가 먼저 오도록 한다.
						_projectByPeriod.projects.sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
					}

					_projectGroup.push(_projectByPeriod)
					return _projectGroup
				}, [])
			} catch (error) {
				alert('죄송합니다. 프로젝트 코드 데이터를 불러오는 도중 장애라 발생했습니다. 개발팀에게 문의주시기 바랍니다.')				
			} finally {
				this.is_loaded_projectCode = true
			}
		},
		openProjectModal() {
			this.edit = 'create'
			this.editing_target_project = {}

			this.$bvModal.show('add-new-project-modal')
		},
		openProjectEditModal (item) {
			this.edit = 'update'
			this.editing_target_project = { ...item }

			this.$bvModal.show('add-new-project-modal')
		},
		async updateProject (_update_project) {
			try {
				if (this.edit === 'create') {
					this.projects[this.currentPeriodIndex].projects.push(_update_project)
				} else {
					const _projects = this.projects[this.currentPeriodIndex].projects
					const project_index = _projects.findIndex(({ id }) => id === _update_project.id)
					if (project_index > -1) {
						this.$set(this.projects[this.currentPeriodIndex].projects, project_index, _update_project)
					} else {
						await this.resetProject({ isError: true })
					}
				}

				this.$bvModal.hide('add-new-project-modal')
				this.$nextTick(() => { this.resetProject() })	
			} catch (error) {
				await this.resetProject({ isError: true })
			}
		},
		async deleteProject (_delete_project) {
			try {
				const _projects = this.projects[this.currentPeriodIndex].projects
				const project_index = _projects.findIndex(({ id }) => id === _delete_project.id)

				if (project_index > -1) {
					_projects.splice(project_index, 1)
					this.$set(this.projects[this.currentPeriodIndex], 'projects', _projects)
				} else {
					await this.resetProject({ isError: true })
				}

				this.$bvModal.hide('add-new-project-modal')
				this.$nextTick(() => { this.resetProject() })	
			} catch (error) {
				await this.resetProject({ isError: true })
			}
		},
		async resetProject ({ project_proto = {}, isError = false } = {}) {
            if (isError) {
				alert('죄송합니다. 처리도중 장애가 발생해 프로젝트 코드 리스트를 다시 불러오겠습니다.')
				await this.getProjecCode()
			} else {
				this.editing_target_project = Object.assign({}, project_proto)
			}
		}
	}
}
</script>

<style lang="scss">
.admin-project-code-page {
    // 페이지 타이틀 아이콘 — 부드러운 primary 톤 배경의 라운드 박스
    .page-title-icon {
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background-color: rgba(13, 110, 253, 0.1);
        color: #0d6efd;
        font-size: 1.15rem;
        flex: 0 0 auto;
    }

    .project-list-card {
        border: 1px solid #edf0f2;
        border-radius: 12px;
        overflow: hidden;

        .card-header {
            border-bottom: 1px solid #edf0f2;
            padding-top: 1rem;
            padding-bottom: 1rem;
        }
    }

    // period 탭 제목 옆 개수 배지
    .period-count-badge {
        font-weight: 600;
        color: #6c757d;
        background-color: #f1f3f5;
    }

    // 활성 탭의 개수 배지는 primary 톤으로 강조
    .nav-tabs .nav-link.active .period-count-badge {
        color: #0d6efd;
        background-color: rgba(13, 110, 253, 0.12);
    }

    // ON/OFF 상태 pill — 일정한 최소 폭으로 정렬감 부여
    .status-pill {
        min-width: 44px;
        font-weight: 600;
        letter-spacing: 0.02em;

        &.badge-light {
            color: #adb5bd;
            background-color: #f1f3f5;
        }
    }

    // 수정 버튼 — 기본은 중립, hover 시에만 primary 강조
    .edit-btn {
        border-color: #dee2e6;
        color: #6c757d;

        &:hover {
            background-color: #0d6efd;
            border-color: #0d6efd;
            color: #fff;
        }
    }

    .f-85 {
        font-size: 0.85rem;
    }
}
</style>